<!-- Ported from the Polaris kit: src/product/components/FoldingGroup.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A titled group that folds: an icon, what the group is, one sentence, how many things it holds, the things, and
// what can be done with the group (New, templates). Composed from the registry Collapsible.
import { useI18n } from 'vue-i18n';
import { ChevronDown16 } from '@carbon/icons-vue';
import { Badge } from '../ui/badge';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '../ui/collapsible';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  count: { type: Number, default: null },
});
const { t } = useI18n();
const open = defineModel('open', { type: Boolean, default: true });
</script>

<template>
  <Collapsible
    v-model:open="open"
    class="grid grid-cols-1 gap-3"
    data-folding-group
  >
    <div class="flex items-start gap-3">
      <span
        v-if="$slots.icon"
        class="flex size-8 shrink-0 items-center justify-center rounded-full bg-polaris-muted text-polaris-foreground p-0"
        aria-hidden="true"
        ><slot name="icon"
      /></span>
      <div class="grid min-w-0 flex-1 gap-0.5">
        <h2 class="flex items-center gap-2 type-polaris-card-title">
          {{ title
          }}<Badge v-if="count !== null" variant="secondary">{{ count }}</Badge>
        </h2>
        <p
          v-if="description"
          class="type-polaris-body text-polaris-muted-foreground"
        >
          {{ description }}
        </p>
      </div>
      <CollapsibleTrigger
        class="flex size-8 shrink-0 items-center justify-center rounded-polaris-md outline-none hover:bg-polaris-accent focus-visible:ring-[3px] focus-visible:ring-polaris-ring/50 p-0"
        :aria-label="
          t(
            open
              ? 'POLARIS.FOLDING_GROUP.FOLD'
              : 'POLARIS.FOLDING_GROUP.UNFOLD',
            { title }
          )
        "
      >
        <ChevronDown16
          class="transition-transform duration-150"
          :class="open ? 'rotate-180' : ''"
          aria-hidden="true"
        />
      </CollapsibleTrigger>
    </div>
    <CollapsibleContent class="grid grid-cols-1 gap-3">
      <slot />
      <div v-if="$slots.actions" class="flex flex-wrap items-center gap-2">
        <slot name="actions" />
      </div>
    </CollapsibleContent>
  </Collapsible>
</template>
